import axiosOverlay from '../../js/axiosOverlay'

const state = {
    categories: null,
    selectedCategory: null,
    iCanWrite: [],
    iCantRead: []
};

const getters = {
    categories: state => state.categories,
    selectedCategory: state => state.selectedCategory,
    iCanWrite: state => state.iCanWrite,
    iCantRead: state => state.iCantRead,
    getCategorieById: (state) => (categorieID) => {
        return JSON.parse(state.categories)?.find(categorie => categorie.id === categorieID) ?? null
    },
    getMyCategorie: (state, getters, rootState, rootGetters) => {
        let myCat = []
        let allCat = JSON.parse(state.categories)
        if (allCat) {
            allCat.forEach(function (categorie) {
                let flag = true
                if (categorie.roleFiltresWrite != null) {
                    rootGetters['user/getRoles'].forEach(function (role) {
                        if (categorie.roleFiltresWrite.includes(role)){
                            flag = false
                        }
                    });
                }
                if (flag) {
                    myCat.push(categorie)
                }
            });
        }
        return myCat
    }
};

const mutations = {
    SET_CATEGORIES(state, categories) {
        state.categories = categories;
    },
    SET_SELECTED_CATEGORY(state, category) {
        state.selectedCategory = category;
    },
    SET_I_CAN_WRITE(state, list) {
        state.iCanWrite = list;
    },
    SET_I_CANT_READ(state, list) {
        state.iCantRead = list;
    }
};

const actions = {
    async loadCategoriesFromAPI({ commit, state, rootGetters }) {
        if (state.categories == null) {
            let config = {
                method: 'get',
                url: process.env.VUE_APP_API_URL + "/sollicitation/categories",
                headers: { }
            };

            try {
                const response = await axiosOverlay(config);
                let result = JSON.stringify(response.data);
                commit('SET_CATEGORIES', result);

                let iCanWrite = [];
                let iCantRead = [];
                let allCat = JSON.parse(result);
                
                allCat.forEach(function (categorie) {
                    // Remplissage de ce que je peux écrire
                    let flagWrite = true;
                    if (categorie.roleFiltresWrite != null) {
                        rootGetters['user/getRoles'].forEach(function (role) {
                            if (categorie.roleFiltresWrite.includes(role)){
                                flagWrite = false;
                            }
                        });
                    }
                    if (flagWrite) {
                        iCanWrite.push(categorie);
                    }

                    // Remplissage de ce que je peux lire
                    let flagRead = true;
                    if (categorie.roleFiltresRead != null) {
                        rootGetters['user/getRoles'].forEach(function (role) {
                            if (categorie.roleFiltresRead.includes(role)){
                                flagRead = false;
                            }
                        });
                    }
                    if (!flagRead) {
                        iCantRead.push(categorie);
                    }
                });
                
                commit('SET_I_CAN_WRITE', iCanWrite);
                commit('SET_I_CANT_READ', iCantRead);
                
            } catch (error) {
                console.log(error);
            }
        }
    },
    
    setSelectedCategory({ commit }, categoryID) {
        commit('SET_SELECTED_CATEGORY', categoryID);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
